module.exports = __webpack_public_path__ + "static/media/ic_frown.f2ff74b7.png";